/* tslint:disable:max-line-length */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getLocalStorage } from '../helpers/helper';
import { key_user_info } from '../helpers/constants';
@Injectable({
  providedIn: 'root',
})
export class BiceCrmService {
  vidaUrl = environment.url.apiBff + '/';
  vidaUrlApi = environment.url.api + '/';
  defaultCaseType = environment.salesForceBice.defaultCaseType;
  defaultSource = environment.salesForceBice.defaultSource;
  defaultSubsidiary = environment.salesForceBice.defaultSubsidiary;
  defaultCompany = environment.salesForceBice.defaultCompany;
  defaultMailingCorrespondence =
    environment.salesForceBice.defaultMailingCorrespondence;
  endpointCrearRescate = 'BffSitioPrivado/CreateCaseCrmBice';

  constructor(private http: HttpClient) {
    const token = getLocalStorage('token');
  }

  public ConsultationDetail(withdrawalType: string, flagPatrimonial: string): string{
    let consultationDetail = '';
    switch (flagPatrimonial) {
      case 'patrimonial':
        consultationDetail = (withdrawalType==='parcial')? 'Solicitud de Rescate Patrimonial Parcial' : 'Solicitud de Rescate Patrimonial Total';
        break;
      case 'noPatrimonial':
        consultationDetail = (withdrawalType==='parcial')? 'Solicitud de Rescate Parcial' : 'Solicitud de Rescate Total';
        break;
    }

    return consultationDetail;
  }

  public DetailRequest(rescueType: string, patrimony: boolean, idPoliza: number, emailEjecutiva: string, 
    infoNombreProducto: string, montoLiquidoForSalesforce: string, bankName: string,bankType: string,
    bankAccountNumber: string

  ): string {
    var detailRequest = '';
    var patrimonyDet = '';

    if (patrimony) patrimonyDet = 'Patrimonial ';

    switch (rescueType) {
      case 'total':
        detailRequest = 'ED - Solicitud de Rescate ' + patrimonyDet + 'Total';
        break;
      case 'parcial':
        detailRequest = 'ED - Solicitud de Rescate ' + patrimonyDet + 'Parcial';
        break;
      default:
        detailRequest = '';
        break;
    }

    return detailRequest + ' Id Poliza:'+ idPoliza.toString() + ' Email Ejecutiva:' + emailEjecutiva
        + ' Nombre Producto: ' + infoNombreProducto + ' Monto Liquido:' + montoLiquidoForSalesforce 
        + ' Banco:' + bankName + ' Tipo:' + bankType + ' Numero de cuenta:'+bankAccountNumber;;
  }

  private personType(rut: string): string {
    var rutNum = parseInt(rut.split('-')[0]);

    if (rutNum < 70000000) {
      return 'natural';
    } else {
      return 'juridica';
    }
  }

  formatToChileanPhone(number: string | number): string {
    if (!number) return '';

    let cleaned = number.toString().replace(/\D/g, '');

    if (cleaned.length === 8) {
      return '+569' + cleaned;
    }
    if (cleaned.length === 9 && cleaned.startsWith('9')) {
      return '+56' + cleaned;
    }
    if (cleaned.length === 11 && cleaned.startsWith('56')) {
      return '+' + cleaned;
    }
    if (cleaned.length === 12 && cleaned.startsWith('56')) {
      return '+' + cleaned;
    }
    return '';
  }

  crearCaso(
    BornDate,
    Phone,
    CellPhone,
    Description,
    ConsultationReason,
    ConsultationDetail,
    BusinessLine,
    Subject,
    CaseNumber,
    Attachments: Array<{ name: string; extension: string; base64: string }>
  ): Observable<any> {
    const token = getLocalStorage('token');

    var headers = new HttpHeaders({
      accept: 'application/json',
      'x-application': 'Sitio Privado',
      'x-ibm-client-id': environment.ClientId,
      Authorization: 'Bearer ' + token.access_token,
    });

    const userInfo = getLocalStorage(key_user_info);
    const body = {
      ClientRut: userInfo.rut.split('-')[0],
      ClientRutDv: userInfo.rut.split('-')[1],
      Names: userInfo.name,
      FatherLastName: userInfo.family_name.split(' ')[0],
      MotherLastName:
        userInfo.family_name.split(' ').length > 1
          ? userInfo.family_name.split(' ')[1]
          : '',
      Email: userInfo.email,
      MailingCorrespondence: this.defaultMailingCorrespondence,
      BornDate,
      Phone: this.formatToChileanPhone(Phone),
      CellPhone,
      Subsidiary: this.defaultSubsidiary,
      CaseType: this.defaultCaseType,
      Description,
      Source: this.defaultSource,
      PersonType: this.personType(userInfo.rut),
      Attachments,
      Company: this.defaultCompany,
      ConsultationReason,
      ConsultationDetail,
      BusinessLine,
      Subject,
      CaseNumber
    };
    const serviceURL =
      this.vidaUrl +
      this.endpointCrearRescate +
      '/' +
      userInfo.rut.split('-').join('');
    return this.http.post(serviceURL, body, {
      headers: headers,
    });
  }
}
